export * from "./create-patient.guard";
export * from "./create-test-order.guard";



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/guard/physician-portal/route-guards/index.ts